import { Component, HostListener, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { FeatherIconsComponent } from '../feather-icons/feather-icons.component';

@Component({
  selector: 'app-tap-to-top',
  templateUrl: './tap-to-top.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FeatherIconsComponent],
})
export class TapToTopComponent implements OnInit {
  show = signal(false);

  constructor(private viewScroller: ViewportScroller) {}

  ngOnInit(): void {
    this.show.set(false);
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const number = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    this.show.set(number > 600);
  }

  tapToTop() {
    this.viewScroller.scrollToPosition([0, 0]);
  }
}
